<div class="container">
  <div class="text-center">
    <div class="loa-details">
      <div class="fs-18 fw600 mb-24">Thanks for completing the contract.</div>
      <div class="loa-text-box-body">
        We are fetching your signed copy.
      </div>
    </div>
  </div>

</div>